import {
  useRef, Dispatch, SetStateAction,
} from 'react';
import classNames from 'classnames';
import styles from './Dropdown.module.css';
import useOutsideAlerter from '../../utils/onClickOutside';

function Dropdown({
  content,
  trigger,
  triggerClassname,
  contentClassname,
  right,
  width,
  open,
  setopen,
  triggerOnClick,
  height,
  dropup = false,
  containerClassname,
}: {
  content: React.ReactNode;
  trigger: React.ReactNode;
  triggerClassname?: string;
  contentClassname?: string;
  containerClassname?: string;
  right?: boolean;
  width: number;
  open: boolean;
  setopen: Dispatch<SetStateAction<boolean>>;
  triggerOnClick?: () => void;
  height?: number;
  dropup?: boolean;
}) {
  const ref = useRef(null);
  const onClickOutside = () => {
    setopen(false);
  };
  useOutsideAlerter(ref, styles.trigger, onClickOutside);

  return (
    <div
      className={classNames(
        'dropdown',
        containerClassname,
        {
          'is-active': open,
          'is-right': right,
          'is-up': dropup,
        },
      )}
    >
      <div className="dropdown-trigger has-fullwidth">
        <div
          className={classNames(
            'button',
            styles.trigger,
            {
              [styles.triggerActive]: open,
            },
            triggerClassname,
          )}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setopen((prevOpen) => !prevOpen);
              if (triggerOnClick) {
                triggerOnClick();
              }
            }
          }}
          aria-haspopup="true"
          aria-controls="dropdown-menu"
          onClick={() => {
            setopen((prevOpen) => !prevOpen);
            if (triggerOnClick) {
              triggerOnClick();
            }
          }}
        >
          {trigger}
        </div>
      </div>
      <div
        className={classNames('dropdown-menu', styles.menu, {
          [styles.menuOpen]: open,
        })}
        id="dropdown-menu"
        role="menu"
        ref={ref}
        style={{ width }}
      >
        <div
          className={classNames(
            'dropdown-content',
            styles.content,
            contentClassname,
            { [styles.contentRight]: right },
          )}
          style={{ width, height }}
        >
          {content}
        </div>
      </div>
    </div>
  );
}

Dropdown.defaultProps = {
  triggerClassname: undefined,
  contentClassname: undefined,
  containerClassname: undefined,
  right: undefined,
  triggerOnClick: undefined,
  height: undefined,
  dropup: undefined,
};

export default Dropdown;
